import { ReactNode } from 'react';
import clsx from 'clsx';

export function Card({ className, children, padded = true }: { className?: string; children: ReactNode; padded?: boolean }) {
  return <div className={clsx('bg-bg hairline rounded-sm', padded && 'p-3', className)}>{children}</div>;
}
